import React from 'react';

import TripsSubmissionHistoryTable from '../../Table/TripsSubmissionHistoryTable';
import GenericModal from '../GenericModal';

const TripsSubmissionHistoryModal = props => {
  const { t, visible, onCancel, submissionHistoryList = [], rbId, rcId } = props;

  const WINDOW_WIDTH = window.innerWidth - 50;
  const MODAL_WIDTH = WINDOW_WIDTH > 1100 ? 1100 : WINDOW_WIDTH;

  return (
    <GenericModal
      centered
      title={t('tripsSubmissionHistory')}
      width={MODAL_WIDTH}
      footer={null}
      visible={visible}
      onCancel={onCancel}
    >
      <TripsSubmissionHistoryTable
        t={t}
        rbId={rbId}
        rcId={rcId}
        dataSource={submissionHistoryList}
      />
    </GenericModal>
  );
};

export default TripsSubmissionHistoryModal;
